/**
 * Zoom au défilement : une photo grossit doucement pendant qu'on descend la page.
 *
 * À poser sur l'élément qui doit porter le zoom :
 *   data-zoom-defilement="6"          ampleur en % (0 ou absent : aucun effet)
 *   data-zoom-defilement-mobile="20"  ampleur sur petit écran (facultatif)
 *   data-zoom-mode="traversee"        (par défaut) ou "sortie"
 *
 * L'ampleur mobile existe parce qu'une photo occupe moins de place sur un
 * téléphone : le même pourcentage y passe presque inaperçu.
 *
 * Deux variables CSS sont posées sur cet élément :
 *   --zoom       l'échelle à appliquer (1 = photo au repos)
 *   --zoom-inv   son inverse, pour ce qui est posé par-dessus la photo et doit
 *                garder sa taille (les points cliquables, par exemple)
 *
 * Modes :
 *   traversee  0 quand la photo pointe par le bas de l'écran, 1 quand elle sort
 *              par le haut. Pour une photo rencontrée en cours de page.
 *   sortie     0 tant que la photo occupe le haut de l'écran, 1 quand elle est
 *              entièrement sortie. Pour une bannière vue dès l'arrivée : elle
 *              doit démarrer au repos, pas à mi-zoom.
 *
 * Rien ne tourne quand la photo est hors écran, et le mouvement réduit du
 * système coupe l'effet.
 */
(function () {
  if (window.zoomDefilementPret) return;
  window.zoomDefilementPret = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var suivis = new Set();
  var actifs = new Set();
  var branche = false;
  var enAttente = false;

  var PETIT_ECRAN = window.matchMedia('(max-width: 749px)');

  function ampleurDe(element) {
    if (PETIT_ECRAN.matches) {
      var mobile = parseFloat(element.dataset.zoomDefilementMobile || '0');
      if (mobile) return mobile;
    }
    return parseFloat(element.dataset.zoomDefilement || '0');
  }

  function calcule(element) {
    var ampleur = ampleurDe(element);
    if (!ampleur) return;

    var rect = element.getBoundingClientRect();
    var hauteurEcran = window.innerHeight || document.documentElement.clientHeight;
    var progression;

    if (element.dataset.zoomMode === 'sortie') {
      progression = rect.height > 0 ? -rect.top / rect.height : 0;
    } else {
      var course = hauteurEcran + rect.height;
      progression = course > 0 ? (hauteurEcran - rect.top) / course : 0;
    }

    var borne = Math.min(Math.max(progression, 0), 1);
    var zoom = 1 + (ampleur / 100) * borne;
    element.style.setProperty('--zoom', zoom.toFixed(4));
    element.style.setProperty('--zoom-inv', (1 / zoom).toFixed(4));
  }

  function rafraichit() {
    enAttente = false;
    actifs.forEach(calcule);
  }

  function demande() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(rafraichit);
  }

  function branchement(actif) {
    if (actif === branche) return;
    branche = actif;
    if (actif) {
      window.addEventListener('scroll', demande, { passive: true });
      window.addEventListener('resize', demande);
    } else {
      window.removeEventListener('scroll', demande);
      window.removeEventListener('resize', demande);
    }
  }

  var observateur = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (entree) {
      var element = entree.target;
      element.classList.toggle('zoom-defilement--actif', entree.isIntersecting);
      if (entree.isIntersecting) {
        actifs.add(element);
      } else {
        actifs.delete(element);
      }
    });
    branchement(actifs.size > 0);
    demande();
  });

  function recense(racine) {
    var cible = racine || document;
    cible.querySelectorAll('[data-zoom-defilement]').forEach(function (element) {
      if (suivis.has(element)) return;
      if (!parseFloat(element.dataset.zoomDefilement || '0')) return;
      suivis.add(element);
      observateur.observe(element);
    });
  }

  function oublie(racine) {
    if (!racine || !racine.querySelectorAll) return;
    racine.querySelectorAll('[data-zoom-defilement]').forEach(function (element) {
      if (!suivis.has(element)) return;
      suivis.delete(element);
      actifs.delete(element);
      observateur.unobserve(element);
    });
    branchement(actifs.size > 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      recense();
    });
  } else {
    recense();
  }

  // Éditeur de thème : les sections sont rechargées à chaud.
  document.addEventListener('shopify:section:load', function (evenement) {
    recense(evenement.target);
  });
  document.addEventListener('shopify:section:unload', function (evenement) {
    oublie(evenement.target);
  });
})();
